<!--[formControl]="listControl"-->
<mat-form-field>
  <mat-select (selectionChange)="onSelectionChange($event)" [compareWith]="compareFn" multiple [(ngModel)]="value" [disabled]="checkForDisabled(getAttribute('name')) || checkForDisabled(bindingProperty) || dfms?.isFormReadOnly == true">

    <mat-select-trigger>
      @for (val of value; track val; let i = $index) {
        <span>{{val[titleField]}}@if (i != value.length -1) {
          <span
          > , </span>
        }</span>
      }
    </mat-select-trigger>

    @for (item of list; track item) {
      <mat-option [value]="item">{{item[titleField]}}</mat-option>
    }
  </mat-select>

</mat-form-field>
